"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformationSimulateOut = void 0;
class TransformationSimulateOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return TransformationSimulateOut.attributeTypeMap;
    }
}
exports.TransformationSimulateOut = TransformationSimulateOut;
TransformationSimulateOut.discriminator = undefined;
TransformationSimulateOut.attributeTypeMap = [
    {
        "name": "method",
        "baseName": "method",
        "type": "TransformationHttpMethod",
        "format": ""
    },
    {
        "name": "payload",
        "baseName": "payload",
        "type": "string",
        "format": ""
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "URI",
        "format": "uri"
    }
];
//# sourceMappingURL=TransformationSimulateOut.js.map